import InteroperableObj from "../InteroperableObj";
import spendMode from "../spendMode";
import O1HD from "../../../engines/gameEngine";

const {ccclass, property} = cc._decorator;

@ccclass
export default class Dog extends InteroperableObj {

    clickCount:number = 0;

    @property({type:cc.Label,displayName:"说话文本"})
    chatLb:cc.Label = null;

    @property({type:cc.Node,displayName:"说话节点"})
    chatNode:cc.Node = null;
    @property({type:cc.Node,displayName:""})
    moneyNode : cc.Node = null;

    @property(spendMode)
    mGameLayer : spendMode = null;

    canClick:boolean = true;

    chatStr:string[] = [
        // "给我钱\n去买狗粮,-1w",
        // "吃饱了",
        // "不要再吃了",
        // "呕~全还你！"
    ]

    onLoad(){
        super.onLoad();
        this.node.on("touchend",this.onTouchEnd,this);
    }

    onTouchEnd(e:cc.Event.EventTouch){
        if(this.clickCount > 10) return;
        if(!this.canClick) return;
        O1HD.getManagers().soundMgr.playSound("dog").then();
        this.canClick = false;
        if(this.clickCount < 6){
            this.showChat(this.chatStr[0]);
            this.mGameLayer.manage.setGameData({_coin : -10000 } , true );
            this._reduceMoneyEffect();
        }else if(this.clickCount >=6 && this.clickCount < 7){
            this.showChat(this.chatStr[1]);
        }else if(this.clickCount >=7 && this.clickCount < 8){
            this.showChat(this.chatStr[2]);
        }else{
            this.showChat(this.chatStr[3]);
            // 狗给钱  事件
            this.mGameLayer.manage.setGameData({_coin : 500000 } , true );
        }
        this.clickCount ++;
    }


    private _reduceMoneyEffect(){
        let effectNode = cc.instantiate( this.moneyNode );
        effectNode.active = true;
        effectNode.setPosition(this.moneyNode.getPosition(cc.v2()));
        this.node.addChild(effectNode);
        cc.tween(effectNode)
            .to(1,{y:50,opacity:100})
            .call(()=>{
                effectNode.removeFromParent();
                effectNode.destroy();
            })
            .start();
    }

    showChat(chat:string){
        cc.Tween.stopAllByTarget(this.chatNode);
        this.chatLb.string = chat;
        cc.tween(this.chatNode).to(0.2,{scale:1}).delay(2).call(()=>{
            cc.tween(this.chatNode).to(0.2,{scale:0}).start();
            this.canClick = true;
        }).start();
    }

    initObj(){
        this.clickCount = 0;
        this.canClick = true;
    }
}
